/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { trackEvent } from 'utils/tracking/tracking';
import { refreshAds } from 'utils/ads';
import { url } from 'utils/urls';
// STYLES
// (css-in-js, imported as JS from external file, turned into CSS via library used in utils)
import styles from 'components/shared/logo/insticator/insticator_styles';
import { createStyles } from 'utils/styles';
import { preloadStyleImages } from "utils/preloader";
preloadStyleImages(styles);
const sheet = createStyles(styles, {link:false});



/* ========== ~~~~~~~~~~ LOGO : INSTICATOR ~~~~~~~~~~ ========== */
// STATELESS FUNCTIONAL COMPONENT
// used to create markup structure and render UI
// doesn't need all the lifecycle functions attached
const InsticatorLogo = (props) => {
	function handleClick(e) {
		// // ::: tracking: logo click ::: //
        trackEvent({ type: 'click', name: 'ceuClicks', target: 'logo', additionalProps: {logo: {type: 'company', brand: 'Insticator', url: url.company, frame: props.frameData }}});
        // refresh advertisements
        refreshAds();
	}
    return props.enableInsticatorBranding ? (
		<a className={`logo ${sheet.classes.insticator} insticator`} href={`https://www.insticator.com/?utm_source=${props.siteURL}&utm_medium=powered_by_insticator`} target="_blank" onClick={handleClick}>
			{props.poweredBy ? <span className={`poweredby`}>powered by </span> : null}
			<span className={`logoimage`}><span className={`accessibility`}> <a href={`https://www.insticator.com`} >http://intsticator.com</a></span></span>
		</a>
    ) : null;
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default InsticatorLogo;
